import { createFileRoute } from '@tanstack/react-router';
import { useActiveRealmAPIContext } from '@interxfi/api-client/realm-context';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import type { IxcAssetsV1AssetTypeOneOfValue } from '@interxfi/types';
import { AssetsTable, type AssetTableHeaderActionProps } from '../../../../../features/asset/assets-table';
import { CreateAssetDrawer } from '../../../../../features/asset/create-asset-drawer';
import { getPageHead } from '../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/asset/_asset/')({
  head: () => getPageHead('Assets'),
  component: AssetSecurityList,
});

const assetTypesAllowedToCreate = ['equity', 'moneyMarket'] as const satisfies IxcAssetsV1AssetTypeOneOfValue[];

function TableHeader({ filter, search }: AssetTableHeaderActionProps) {
  const { activeTenantIsClearing } = useActiveRealmAPIContext();

  return (
    <VerticalStack gap={7}>
      <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {activeTenantIsClearing ? (
            <RequiresAccess write>
              <CreateAssetDrawer
                allowedTypes={assetTypesAllowedToCreate}
                trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Security" size="small" />}
              />
            </RequiresAccess>
          ) : null}
          {filter}
        </HorizontalStack>
      </HorizontalStack>
      {search}
    </VerticalStack>
  );
}

function AssetSecurityList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <AssetsTable HeaderActions={TableHeader} viewContext="securities" />
      </PageLayout.Section>
    </PageLayout>
  );
}
